import React from 'react'
import { Button, Typography } from 'antd'
import './offlinePage.less'

const { Paragraph } = Typography

const OfflinePage: React.FC = () => {
  // 跳转到北极星系统
  const goToPolarSystem = () => {
    const host = window.__IS_GALAXY_PROD
      ? 'https://bike.sankuai.com'
      : window.__IS_GALAXY_ST
      ? 'https://ops.bike.st.sankuai.com'
      : 'https://ops.bike.test.sankuai.com'
    const POLAR_LINK = `${host}/#/galaxy/dataPushList`
    window.open(POLAR_LINK, '_blank')
  }

  // 查看SOP文档
  const viewSOP = () => {
    window.open('https://km.sankuai.com/collabpage/2714540650', '_blank')
  }

  return (
    <div className="system-offline-container">
      <div className="system-offline-content">
        <div className="system-offline-message">
          <Paragraph>尊敬的用户：您好！</Paragraph>
          <Paragraph>
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;为满足公司对业务系统安全性要求，现已将【骑行监管平台-后台管理模块】统一迁移至北极星系统，该模块下的功能包括：权限管理、数据对接管理、数据调优管理、备案信息管理、信用管理等。需通过北极星系统访问原功能模块
            <Button type="link" onClick={goToPolarSystem} className="link-button">
              (访问链接)
            </Button>
            ，若无权限请参照
            <Button type="link" onClick={viewSOP} className="link-button">
              SOP
            </Button>
            完成权限申请，权限相关问题可咨询GA中台(yangchunxu02/miaopeiliang)、运营中台(chengzhuo08)。
          </Paragraph>
          <Paragraph className="tip">
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;说明：本次迁移的功能模块仅限内部用户使用，不对外部用户开放，本次迁移对外部用户（如G端治理者、合作商等）无影响。
          </Paragraph>
        </div>
      </div>
    </div>
  )
}

export default OfflinePage
